function formatValidationMessage(result) {
  return (result.schema.title || result.property) + ' ' + result.message;
}

function formatValidationMessages(resultArray) {
  return resultArray.map(formatValidationMessage);
}

export { formatValidationMessage, formatValidationMessages };
